<button sdButton type="unset" size="unset" (click)="download()">
  <cx-icon type="DOWNLOAD"></cx-icon>
  <span>{{ 'Скачать' }}</span>
</button>
